






















import Vue, { computed } from "vue";
import Component from "vue-class-component";
import { PropSync } from "vue-property-decorator";
import { UserPromotionListEntry } from "../../../types";
import Discord from "../../../Discord";
import DateUtility from "../../../DateUtility";


@Component({
  components: {},
})
export default class UserPromotionListItem extends Vue {
  @PropSync("signedUp")
  public signedUpProp!: boolean;
  @PropSync("messaged")
  public messagedProp!: boolean;
  @PropSync("userPromotionListEntry")
  public userPromotionListEntryProp!: UserPromotionListEntry;
  @PropSync("message", {required: false})
  public messageProp!: string | null;

  public get avatar(): string {
    return Discord.avatarSourceUri(this.userPromotionListEntryProp.id, this.userPromotionListEntryProp.avatar);
  }

  public get formatedDate(): string {
    if (this.userPromotionListEntryProp.latestSignup === null) {
      return "";
    }
    const moment = DateUtility.getDate(this.userPromotionListEntryProp.latestSignup);
    return moment.toDate().toLocaleDateString();
  }
}
